<template>
  <div class="center-content">
    <dx-pie-chart
      id="pie"
      :title="title"
      :data-source="data"
      :palette="palette"
    >
      <dx-series argument-field="type" value-field="size">
        <dx-label
          :visible="true"
          position="inside"
          :customize-text="customizeLabel"
        />
      </dx-series>
      <dx-size :width="300" />
    </dx-pie-chart>
  </div>
</template>
<script>
import DxPieChart, {
  DxSeries,
  DxSize,
  DxLabel,
} from "devextreme-vue/pie-chart";

export default {
  name: "pieChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    palette: {
      type: String,
      required: false,
      default: "Material",
    },
  },
  methods: {
    customizeLabel({ arg, value }) {
      return `${value} MB`;
    },
  },
  components: {
    DxPieChart,
    DxSeries,
    DxSize,
    DxLabel,
  },
};
</script>
<style scoped>
.center-content {
  display: flex;
  justify-content: center;
}
</style>